type Props = {
  name: string;
  type: string | undefined;
};

export const TagItem = ({ name, type }: Props) => {
  if (type === 'Good') {
    return (
      <div className="inline-flex h-4 items-center justify-center gap-2 rounded-[40px] bg-review-tag px-2">
        <div className="font-body text-[8px] font-medium text-review-background">{name}</div>
      </div>
    );
  } else {
    return (
      <div className="inline-flex h-4 items-center justify-center gap-2 rounded-[40px] border border-dashed border-review-tag-border px-2">
        <div className="font-body text-[8px] font-medium text-review-tag-foreground">{name}</div>
      </div>
    );
  }
};
